// Phaser 4 遊戲全域設定
// 對應 PRD §1.1 技術選型、§9.1 解析度與縮放
//
// 集中管理：邏輯解析度、背景色、scale 模式、render 選項。
// 之後若要調整畫面大小、改 pixel art 風格、加 physics，都改這裡。

import Phaser from 'phaser';

// 邏輯畫布尺寸：1280×720（16:9）
// 不論玩家螢幕多大，遊戲座標一律以這個尺寸為基準
// Phaser 的 Scale.FIT 模式會自動等比縮放到實際視窗大小
export const LOGICAL_WIDTH = 1280;
export const LOGICAL_HEIGHT = 720;

// 畫面中心（衍生自邏輯尺寸）— 各元件置中對齊共用，避免重複寫 LOGICAL_WIDTH / 2
export const SCREEN_CENTER_X = LOGICAL_WIDTH / 2;
export const SCREEN_CENTER_Y = LOGICAL_HEIGHT / 2;

// 牌桌綠（深綠）— 整個遊戲的預設背景色
// 同時作為 index.html body 背景色，確保載入時不會閃白
export const TABLE_BG_COLOR = '#0a3d2e';

/**
 * 產生 Phaser.Game 設定物件。
 *
 * 接受 Scene 陣列當參數，是為了讓 main.ts 集中註冊 Scene，
 * 設定本身不直接 import Scene（避免循環依賴）。
 */
export const buildGameConfig = (
  scenes: Phaser.Types.Scenes.SceneType[]
): Phaser.Types.Core.GameConfig => ({
  // AUTO：優先用 WebGL，不支援時自動 fallback 到 Canvas
  type: Phaser.AUTO,

  // 掛載到 index.html 的 <div id="app">
  parent: 'app',

  backgroundColor: TABLE_BG_COLOR,

  scale: {
    // FIT：等比縮放到視窗大小，可能上下或左右會有黑邊
    // 比 RESIZE 模式安全，UI 座標不會跑掉
    mode: Phaser.Scale.FIT,
    // 自動把遊戲畫面置中（搭配 FIT 用）
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: LOGICAL_WIDTH,
    height: LOGICAL_HEIGHT,
  },

  render: {
    // 麻將牌面是高解析的圖片，不需要 pixel art 模式
    pixelArt: false,
    // 開抗鋸齒，文字與牌面邊緣較順
    antialias: true,
  },

  scene: scenes,
});
